import { OnInit, Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit{
    constructor(){}

    ngOnInit(){}
}